import script from "./ListarEmarketingRespinativos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarEmarketingRespinativos.vue?vue&type=script&setup=true&lang=js"

import "./ListarEmarketingRespinativos.vue?vue&type=style&index=0&id=316cfb9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-316cfb9e"]])

export default __exports__